// Si tienes un Environment model, déjalo; si no, puedes omitir la import.
// import { Environment } from './environment.model';

// export const environment: Environment = {
export const environment = {
	name: 'stg',
	production: true,

	// Backend base y baseHref de la app (ajústalos si tu router usa otro baseHref)
	// STG (aliadodigital) sale por el API gateway PRODUCTIVO (IBM API Connect apibalancer,
	// org cmv, catálogo onboarding). Ese catálogo enruta al backend de STG (cmv4086:9392).
	// El gateway de QA (apigatewayqa:2053/cmv-dev/onboarding-stg) ya no se usa desde STG.
	urlBase: 'https://apigateway.cajamorelia.com.mx/cmv/onboarding',
	baseHref: '/onboarding/',

	// clientID es el X-IBM-Client-Id del gateway productivo (app onboarding-web-app),
	// NO es de Incode. Es el mismo que usa environment.prod.ts.
	clientID: 'f77f7d2166db236b83a00ca834e33ce3',

	// Incode
	incodeUrl: 'https://saas-api.incodesmile.com/',
	incodeConfigurationId: '64cd4cfa88a0236898e10f81',
	incodeClientId: '5mfcajam847',
	incodeLanguage: 'es',
	cmvPlusServices:
		'https://apigateway.cajamorelia.com.mx/cmv/cmv-plus-services/',
	// X-IBM-Client-Id del catálogo cmv-plus-services en el gateway productivo (app cmv-plus-services-app).
	cmvplusClientID: 'e31a34c501ce5573543c6e6a1d6fac40',
	personIdQa: 770170,
	client_id: 'crm',
	grant_type: 'client_credentials',
	client_secret: 'f2xLnOcYDRj71zSSg15sIt7MuB8DurT3',
	x_branch_Id: '222',
	x_channel_Id: 'PLD',
	x_api_version: '1.0',
	turnstileSiteKey: '0x4AAAAAADLDJ1f70FU-w5nw',
};
